import { TrackingEventLabels as BaseTrackingEventLabels } from '../../common/tracking/tracking-event-labels.model';

export const TrackingEventLabels = {
  ...BaseTrackingEventLabels,
  // ASSET TEMPLATE SHELL
  OPEN_ASSET_TEMPLATE_CREATE_DIALOG: 'open_asset_template_create_dialog',
  CREATE_ASSET_TEMPLATE: 'create_asset_template',
  REFRESH_ASSET_TEMPLATE_SHELL_DATA: 'refresh_asset_template_shell_data',
  OPEN_ASSET_TEMPLATE_DETAILS_POPUP: 'open_asset_template_details_popup',
  NAVIGATE_TO_ASSET_TEMPLATE_OVERVIEW_PAGE: 'navigate_to_asset_template_overview_page',
  OPEN_ASSET_TEMPLATE_UPDATE_DIALOG: 'open_asset_template_update_dialog',
  UPDATE_ASSET_TEMPLATE: 'update_asset_template',
  OPEN_ASSET_TEMPLATE_DELETE_DIALOG: 'open_asset_template_delete_dialog',
  DELETE_ASSET_TEMPLATE: 'delete_asset_template',
  // ASSET TEMPLATE OVERVIEW
  OPEN_ASSET_TEMPLATE_VARIABLE_CREATE_DIALOG: 'open_asset_template_variable_create_dialog',
  CREATE_ASSET_TEMPLATE_VARIABLE: 'create_asset_template_variable',
  OPEN_ASSET_TEMPLATE_VARIABLE_CONFIGURE_DIALOG: 'open_asset_template_variable_configure_dialog',
  CONFIGURE_ASSET_TEMPLATE_VARIABLE: 'configure_asset_template_variable',
  OPEN_TEMPLATE_UPDATE_DIALOG: 'open_template_update_dialog',
  UPDATE_TEMPLATE: 'update_template',
  OPEN_ASSET_TEMPLATE_PRODUCTS_CONFIGURE_DIALOG: 'open_asset_template_products_configure_dialog',
  CONFIGURE_ASSET_TEMPLATE_PRODUCTS: 'configure_asset_template_products',
  OPEN_ASSET_TEMPLATE_PRODUCTS_DELETE_DIALOG: 'open_asset_template_products_delete_dialog',
  DELETE_ASSET_TEMPLATE_PRODUCTS: 'delete_asset_template_products',
  OPEN_ASSET_TEMPLATE_OPTIONAL_PROPERTIES_CONFIGURE_DIALOG: 'open_asset_template_optional_properties_configure_dialog',
  CONFIGURE_ASSET_TEMPLATE_OPTIONAL_PROPERTIES: 'configure_asset_template_optional_properties',
  OPEN_ASSET_TEMPLATE_TAGS_CONFIGURE_DIALOG: 'open_asset_template_tags_configure_dialog',
  CONFIGURE_ASSET_TEMPLATE_TAGS: 'configure_asset_template_tags',
  OPEN_ASSET_TEMPLATE_FOLLOWED_VARIABLES_ADD_DIALOG: 'open_asset_template_followed_variables_add_dialog',
  ADD_ASSET_TEMPLATE_FOLLOWED_VARIABLES: 'add_asset_template_followed_variables',
  REMOVE_ASSET_TEMPLATE_FOLLOWED_VARIABLES: 'remove_asset_template_followed_variables',
  OPEN_ASSET_TEMPLATE_VARIABLE_UPDATE_DIALOG: 'open_asset_template_variable_update_dialog',
  UPDATE_ASSET_TEMPLATE_VARIABLE: 'update_asset_template_variable',
  OPEN_ASSET_TEMPLATE_VARIABLE_DELETE_DIALOG: 'open_asset_template_variable_delete_dialog',
  DELETE_ASSET_TEMPLATE_VARIABLE: 'delete_asset_template_variable',
  OPEN_ASSET_TEMPLATE_VARIABLE_BULK_DELETE_DIALOG: 'open_asset_template_variable_bulk_delete_dialog',
  BULK_DELETE_ASSET_TEMPLATE_VARIABLE: 'bulk_delete_asset_template_variable',
  OPEN_ASSET_TEMPLATE_AUDIT_TRAIL_POPUP: 'open_asset_template_audit_trail_popup',
  REFRESH_ASSET_TEMPLATE_OVERVIEW_DATA: 'refresh_asset_template_overview_data',
  OPEN_ASSET_TEMPLATE_VARIABLE_DETAIL_POPUP: 'open_asset_template_variable_detail_popup',
  // USER SHELL
  OPEN_USER_CREATE_DIALOG: 'open_user_create_dialog',
  CREATE_USER: 'create_user',
  REFRESH_USER_SHELL_DATA: 'refresh_user_shell_data',
  OPEN_USER_FILTER_ENGINE: 'open_user_filter_engine',
  EXPORT_USER_DATA: 'export_user_data',
  OPEN_USER_DETAILS_POPUP: 'open_user_details_popup',
  NAVIGATE_TO_USER_OVERVIEW_PAGE: 'navigate_to_user_overview_page',
  ENABLE_USER: 'enable_user',
  DISABLE_USER: 'disable_user',
  RESEND_USER_VALIDATION_LINK: 'resend_user_validation_link',
  // USER OVERVIEW
  REFRESH_USER_OVERVIEW_DATA: 'refresh_user_overview_data',
  OPEN_USER_AUDIT_TRAIL_POPUP: 'open_user_audit_trail_popup',
  OPEN_USER_UPDATE_DIALOG: 'open_user_update_dialog',
  UPDATE_USER: 'update_user',
  // PO EVENT RULE SHELL
  REFRESH_PO_EVENT_RULE_SHELL_DATA: 'refresh_po_event_rule_shell_data',
  OPEN_PO_EVENT_RULE_FILTER_ENGINE: 'open_po_event_rule_filter_engine',
  OPEN_PO_EVENT_RULE_DETAILS_POPUP: 'open_po_event_rule_details_popup',
  OPEN_PO_EVENT_RULE_CREATE_DIALOG: 'open_po_event_rule_create_dialog',
  CREATE_PO_EVENT_RULE: 'create_po_event_rule',
  OPEN_CONFIGURE_PO_EVENT_DIALOG_RULE: 'open_configure_po_event_rule_dialog',
  CONFIGURE_PO_EVENT_RULE: 'configure_po_event_rule',
  OPEN_EDIT_PO_EVENT_DIALOG_RULE: 'open_edit_po_event_rule_dialog',
  EDIT_PO_EVENT_RULE: 'edit_po_event_rule',
  OPEN_DELETE_PO_EVENT_DIALOG_RULE: 'open_delete_po_event_rule_dialog',
  DELETE_PO_EVENT_RULE: 'delete_po_event_rule',
  NAVIGATE_TO_PO_EVENT_RULE_OVERVIEW_PAGE_FROM_POPUP: 'navigate_to_po_event_rule_overview_page_from_popup',
  NAVIGATE_TO_PO_EVENT_RULE_OVERVIEW_PAGE_FROM_GRID: 'navigate_to_po_event_rule_overview_page_from_grid',
  // PO EVENT RULE OVERVIEW
  REFRESH_PO_EVENT_RULE_OVERVIEW_DATA: 'refresh_po_event_rule_overview_data',
  OPEN_PO_EVENT_RULE_AUDIT_TRAIL_POPUP: 'open_po_event_rule_audit_trail_popup',
  // PRODUCTS CATALOGS
  OPEN_PRODUCT_CREATE_DIALOG: 'open_product_create_dialog',
  CREATE_PRODUCT: 'create_product',
  OPEN_PRODUCT_EDIT_DIALOG: 'open_product_edit_dialog',
  EDIT_PRODUCT: 'edit_product',
  OPEN_PRODUCT_DELETE_DIALOG: 'open_product_delete_dialog',
  DELETE_PRODUCT: 'delete_product',
  OPEN_CATALOG_CREATE_DIALOG: 'open_catalog_create_dialog',
  CREATE_CATALOG: 'create_catalog',
  OPEN_CATALOG_EDIT_DIALOG: 'open_catalog_edit_dialog',
  EDIT_CATALOG: 'edit_catalog',
  OPEN_CATALOG_DELETE_DIALOG: 'open_catalog_delete_dialog',
  DELETE_CATALOG: 'delete_catalog',
  REFRESH_PRODUCT_CATALOGS_SHELL_DATA: 'refresh_product_catalogs_shell_data',
  OPEN_PRODUCT_CATALOGS_FILTER_ENGINE: 'open_product_catalogs_filter_engine',
  EXPORT_PRODUCT_CATALOGS_DATA: 'export_product_catalogs_data',
  // ESCALATION PROTOCOLS SHELL
  OPEN_ESCALATION_PROTOCOL_DETAILS_POPUP: 'open_escalation_protocol_details_popup',
  OPEN_ESCALATION_PROTOCOL_CREATE_DIALOG: 'open_escalation_protocol_create_dialog',
  CREATE_ESCALATION_PROTOCOL: 'create_escalation_protocol',
  OPEN_ESCALATION_PROTOCOL_EDIT_DIALOG: 'open_escalation_protocol_edit_dialog',
  EDIT_ESCALATION_PROTOCOL: 'edit_escalation_protocol',
  OPEN_ESCALATION_PROTOCOL_DELETE_DIALOG: 'open_escalation_protocol_delete_dialog',
  DELETE_ESCALATION_PROTOCOL: 'delete_escalation_protocol',
  NAVIGATE_TO_ESCALATION_PROTOCOL_OVERVIEW_PAGE_FROM_POPUP: 'navigate_to_escalation_protocol_overview_page_from_popup',
  NAVIGATE_TO_ESCALATION_PROTOCOL_OVERVIEW_PAGE_FROM_GRID: 'navigate_to_escalation_protocol_overview_page_from_grid',
  REFRESH_ESCALATION_PROTOCOLS_SHELL_DATA: 'refresh_escalation_protocols_shell_data',
  OPEN_ESCALATION_PROTOCOLS_FILTER_ENGINE: 'open_escalation_protocols_filter_engine',
  EXPORT_ESCALATION_PROTOCOLS_DATA: 'export_escalation_protocols_data',
  // ESCALATION PROTOCOLS OVERVIEW
  REFRESH_ESCALATION_PROTOCOL_OVERVIEW_DATA: 'refresh_escalation_protocol_overview_data',
  OPEN_ESCALATION_PROTOCOL_AUDIT_TRAIL_POPUP: 'open_escalation_protocol_audit_trail_popup',
  OPEN_ESCALATION_PROTOCOL_LEVEL_ADD_DIALOG: 'open_escalation_protocol_level_add_dialog',
  OPEN_ESCALATION_PROTOCOL_LEVEL_DETAILS_POPUP: 'open_escalation_protocol_level_details_popup',
  ADD_ESCALATION_PROTOCOL_LEVEL: 'add_escalation_protocol_level',
  OPEN_ESCALATION_PROTOCOL_LEVEL_EDIT_DIALOG: 'open_escalation_protocol_level_edit_dialog',
  EDIT_ESCALATION_PROTOCOL_LEVEL: 'edit_escalation_protocol_level',
  EDIT_ESCALATION_PROTOCOL_LEVELS_ORDER: 'edit_escalation_protocol_levels_order',
  OPEN_ESCALATION_PROTOCOL_LEVEL_DELETE_DIALOG: 'open_escalation_protocol_level_delete_dialog',
  DELETE_ESCALATION_PROTOCOL_LEVEL: 'delete_escalation_protocol_level',
  OPEN_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS: 'open_escalation_protocol_topic_subscriptions',
  OPEN_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS_MANAGE_DIALOG: 'open_escalation_protocol_topic_subscriptions_manage_dialog',
  MANAGE_ESCALATION_PROTOCOL_TOPIC_SUBSCRIPTIONS: 'manage_escalation_protocol_topic_subscriptions',
  // TOPICS SHELL
  OPEN_TOPIC_DETAILS_POPUP: 'open_topic_details_popup',
  OPEN_TOPIC_CREATE_DIALOG: 'open_topic_create_dialog',
  CREATE_TOPIC: 'create_topic',
  OPEN_TOPIC_EDIT_DIALOG: 'open_topic_edit_dialog',
  EDIT_TOPIC: 'edit_topic',
  OPEN_TOPIC_DELETE_DIALOG: 'open_topic_delete_dialog',
  OPEN_TOPIC_MANAGE_SUBSCRIBERS_DIALOG: 'open_topic_manage_subscribers_dialog',
  OPEN_TOPIC_MANAGE_PROTOCOLS_DIALOG: 'open_topic_manage_protocols_dialog',
  DELETE_TOPIC: 'delete_topic',
  NAVIGATE_TO_TOPIC_OVERVIEW_PAGE_FROM_POPUP: 'navigate_to_topic_overview_page_from_popup',
  NAVIGATE_TO_TOPIC_OVERVIEW_PAGE_FROM_GRID: 'navigate_to_topic_overview_page_from_grid',
  REFRESH_TOPICS_SHELL_DATA: 'refresh_topics_shell_data',
  OPEN_TOPICS_FILTER_ENGINE: 'open_topics_filter_engine',
  EXPORT_TOPICS_DATA: 'export_topics_data',
  OPEN_TOPIC_TOGGLE_SUBSCRIPTION_DIALOG: 'open_topic_toggle_subscription_dialog',
  SUBSCRIBE_SELF_TO_TOPIC: 'subscribe_self_to_topic',
  UNSUBSCRIBE_SELF_FROM_TOPIC: 'unsubscribe_self_from_topic',
  // TOPICS OVERVIEW
  REFRESH_TOPIC_OVERVIEW_DATA: 'refresh_topic_overview_data',
  OPEN_TOPIC_AUDIT_TRAIL_POPUP: 'open_topic_audit_trail_popup',
  OPEN_TOPIC_EDIT_DIALOG_FROM_OVERVIEW: 'open_topic_edit_dialog_from_overview',
  OPEN_TOPIC_CONFIGURE_DIALOG: 'open_topic_configure_dialog',
  CONFIGURE_TOPIC: 'configure_topic',
  OPEN_TOPIC_MANAGE_SUBSCRIBERS_DIALOG_FROM_OVERVIEW: 'open_topic_manage_subscribers_dialog_from_overview',
  OPEN_TOPIC_MANAGE_PROTOCOLS_DIALOG_FROM_OVERVIEW: 'open_topic_manage_protocols_dialog_from_overview',
  OPEN_TOPIC_DELETE_DIALOG_FROM_OVERVIEW: 'open_topic_delete_dialog_from_overview',
  OPEN_TOPIC_TOGGLE_SUBSCRIPTION_DIALOG_FROM_OVERVIEW: 'open_topic_toggle_subscription_dialog_from_overview',
  // EMAIL TEMPLATES SHELL
  REFRESH_EMAIL_TEMPLATES_SHELL_DATA: 'refresh_email_templates_shell_data',
  // API KEYS SHELL
  OPEN_API_KEY_DETAIL_POPUP: 'open_api_key_detail_popup',
  OPEN_API_KEY_CREATE_DIALOG: 'open_api_key_create_dialog',
  CREATE_API_KEY: 'create_api_key',
  OPEN_API_KEY_DELETE_DIALOG: 'open_api_key_delete_dialog',
  DELETE_API_KEY: 'delete_api_key',
  OPEN_API_KEY_EDIT_DIALOG: 'open_api_key_edit_dialog',
  EDIT_API_KEY: 'edit_api_key',
  ENABLE_API_KEY: 'enable_api_key',
  DISABLE_API_KEY: 'disable_api_key',
  OPEN_API_KEY_RENEW_DIALOG: 'open_api_key_renew_dialog',
  RENEW_API_KEY: 'renew_api_key',
  OPEN_API_KEY_MANAGE_USAGE_PLAN_DIALOG: 'open_api_key_manage_usage_plan_dialog',
  MANAGE_API_KEY_USAGE_PLAN: 'manage_api_key_usage_plan',
  // DATA GUARD
  OPEN_DATA_GUARD: 'open_data_guard',
  CLOSE_DATA_GUARD: 'close_data_guard',
  // SCHEDULERS SHELL
  OPEN_SCHEDULER_DETAILS_POPUP: 'open_scheduler_details_popup',
  OPEN_SCHEDULER_CREATE_DIALOG: 'open_scheduler_create_dialog',
  CREATE_SCHEDULER: 'create_scheduler',
  OPEN_SCHEDULER_EDIT_DIALOG: 'open_scheduler_edit_dialog',
  EDIT_SCHEDULER: 'edit_scheduler',
  OPEN_SCHEDULER_DELETE_DIALOG: 'open_scheduler_delete_dialog',
  DELETE_SCHEDULER: 'delete_scheduler',
  NAVIGATE_TO_SCHEDULER_OVERVIEW_PAGE: 'navigate_to_scheduler_overview_page',
  LAUNCH_SCHEDULER_NOW: 'launch_scheduler_now',
  NAVIGATE_TO_SCHEDULER_ADD_DEVICES: 'navigate_to_scheduler_add_devices',
  NAVIGATE_TO_SCHEDULER_REMOVE_DEVICES: 'navigate_to_scheduler_remove_devices',
  REFRESH_SCHEDULERS_SHELL_DATA: 'refresh_schedulers_shell_data',
  OPEN_SCHEDULERS_FILTER_ENGINE: 'open_schedulers_filter_engine',
  // SCHEDULER OVERVIEW
  REFRESH_SCHEDULER_OVERVIEW_DATA: 'refresh_scheduler_overview_data',
  OPEN_SCHEDULER_AUDIT_TRAIL_POPUP: 'open_scheduler_audit_trail_popup',
  OPEN_SCHEDULER_CONFIGURE_DIALOG: 'open_scheduler_configure_dialog',
  CONFIGURE_SCHEDULER: 'configure_scheduler',
  LAUNCH_SCHEDULER: 'launch_scheduler',
  // SCHEDULER OVERVIEW - DEVICES TABS
  OPEN_DEVICE_DETAILS_POPUP: 'open_device_details_popup',
  NAVIGATE_TO_DEVICE: 'navigate_to_device',
  NAVIGATE_TO_SITE: 'navigate_to_site',
  ADD_SINGLE_DEVICE: 'add_single_device',
  ADD_BULK_DEVICES: 'add_bulk_devices',
  REMOVE_SINGLE_DEVICE: 'remove_single_device',
  REMOVE_BULK_DEVICES: 'remove_bulk_devices'
};
